var $, perflibLoader;

perflibLoader = require('../../src/frontend/core/perflibLoader');

perflibLoader();

$ = window.$ = window.jQuery = require('jquery');

require('../../src/frontend/core/jquery.safe-ready')($);

require('../../src/frontend/core/jquery.addons')($);

require('./groupon_modules/placeholder_field')($);

require('./common/core_libraries');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9scy1jb3JlLXZNSU5PUl9WLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL2NvcmUvZnJvbnRlbmQvbHMtY29yZS12TUlOT1JfVi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxhQUFBLEdBQWdCLE9BQUEsQ0FBUSx1Q0FBUjs7QUFDaEIsYUFBQSxDQUFBOztBQUNBLENBQUEsR0FBSSxNQUFNLENBQUMsQ0FBUCxHQUFXLE1BQU0sQ0FBQyxNQUFQLEdBQWdCLE9BQUEsQ0FBUSxRQUFSOztBQUMvQixPQUFBLENBQVEsMkNBQVIsQ0FBQSxDQUFxRCxDQUFyRDs7QUFDQSxPQUFBLENBQVEsdUNBQVIsQ0FBQSxDQUFpRCxDQUFqRDs7QUFDQSxPQUFBLENBQVEscUNBQVIsQ0FBQSxDQUErQyxDQUEvQzs7QUFDQSxPQUFBLENBQVEseUJBQVIifQ==
